// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QMjs","largestCol":"styles_largestCol__h_prn","smallestCol":"styles_smallestCol__31ITS"};